import {
  FORMS_LIST,
  FORMS_LIST_SUCCESS,
  FORMS_LIST_FAILURE,
  FORMS_RENDER,
  FORMS_RENDER_SUCCESS,
  FORMS_RENDER_FAILURE,
  FORMS_SAVE,
  FORMS_SAVE_SUCCESS,
  FORMS_SAVE_FAILURE,
  FORMS_PUBLISH,
  FORMS_PUBLISH_SUCCESS,
  FORMS_PUBLISH_FAILURE,
  FORMS_UNPUBLISH,
  FORMS_UNPUBLISH_SUCCESS,
  FORMS_UNPUBLISH_FAILURE,
  FORMS_DUPLICATE,
  FORMS_DUPLICATE_SUCCESS,
  FORMS_DUPLICATE_FAILURE,
  FORMS_DELETE,
  FORMS_DELETE_SUCCESS,
  FORMS_DELETE_FAILURE,
  FORMS_SUBMISSIONS,
  FORMS_SUBMISSIONS_SUCCESS,
  FORMS_SUBMISSIONS_FAILURE,
  FORMS_SUBMISSION_DATA,
  FORMS_SUBMISSION_DATA_SUCCESS,
  FORMS_SUBMISSION_DATA_FAILURE,
  // Task 24888 - the company's own form statuses.
  FORM_STATUS_LIST,
  FORM_STATUS_LIST_SUCCESS,
  FORM_STATUS_LIST_FAILURE,
  FORM_STATUS_CREATE,
  FORM_STATUS_CREATE_SUCCESS,
  FORM_STATUS_CREATE_FAILURE,
  FORM_STATUS_UPDATE,
  FORM_STATUS_UPDATE_SUCCESS,
  FORM_STATUS_UPDATE_FAILURE,
  FORM_STATUS_DELETE,
  FORM_STATUS_DELETE_SUCCESS,
  FORM_STATUS_DELETE_FAILURE,
  FORMS_SET_STATUS,
  FORMS_SET_STATUS_SUCCESS,
  FORMS_SET_STATUS_FAILURE,
} from "./actionType";

const initialValue = {
  // Task 24888 - the company's own form statuses.
  formStatusList: [],
  formStatusListLoading: false,
  formStatusListError: null,

  formStatusCreate: [],
  formStatusCreateLoading: false,
  formStatusCreateError: null,

  formStatusUpdate: [],
  formStatusUpdateLoading: false,
  formStatusUpdateError: null,

  formStatusDelete: [],
  formStatusDeleteLoading: false,
  formStatusDeleteError: null,

  formsSetStatus: [],
  formsSetStatusLoading: false,
  formsSetStatusError: null,

  formsList: [],
  formsListLoading: false,
  formsListError: null,

  formsRender: [],
  formsRenderLoading: false,
  formsRenderError: null,

  formsSave: [],
  formsSaveLoading: false,
  formsSaveError: null,

  formsPublish: [],
  formsPublishLoading: false,
  formsPublishError: null,

  formsUnpublish: [],
  formsUnpublishLoading: false,
  formsUnpublishError: null,

  formsDuplicate: [],
  formsDuplicateLoading: false,
  formsDuplicateError: null,

  formsDelete: [],
  formsDeleteLoading: false,
  formsDeleteError: null,

  formsSubmissions: [],
  formsSubmissionsLoading: false,
  formsSubmissionsError: null,

  formsSubmissionData: [],
  formsSubmissionDataLoading: false,
  formsSubmissionDataError: null,
};

const Forms = (state = initialValue, action) => {
  switch (action.type) {
    // List
    case FORMS_LIST:
      return {
        ...state,
        formsListLoading: true,
        formsListError: null,
      };
    case FORMS_LIST_SUCCESS:
      return {
        ...state,
        formsList: action.payload,
        formsListLoading: false,
      };
    case FORMS_LIST_FAILURE:
      return {
        ...state,
        formsListLoading: false,
        formsListError: action.payload,
      };

    // Render (full nested bundle)
    case FORMS_RENDER:
      return {
        ...state,
        // Change #100020 - drop the previous form's bundle when another is
        // requested, so nothing can mistake it for the new one.
        formsRender: [],
        formsRenderLoading: true,
        formsRenderError: null,
      };
    case FORMS_RENDER_SUCCESS:
      return {
        ...state,
        formsRender: action.payload,
        formsRenderLoading: false,
      };
    case FORMS_RENDER_FAILURE:
      return {
        ...state,
        formsRenderLoading: false,
        formsRenderError: action.payload,
      };

    // Save
    case FORMS_SAVE:
      return {
        ...state,
        formsSaveLoading: true,
        formsSaveError: null,
      };
    case FORMS_SAVE_SUCCESS:
      return {
        ...state,
        formsSave: action.payload,
        formsSaveLoading: false,
      };
    case FORMS_SAVE_FAILURE:
      return {
        ...state,
        formsSaveLoading: false,
        formsSaveError: action.payload,
      };

    // Publish
    // Task 24888 - the company's own form statuses.
    case FORM_STATUS_LIST:
      return { ...state, formStatusListLoading: true, formStatusListError: null };
    case FORM_STATUS_LIST_SUCCESS:
      return { ...state, formStatusList: action.payload, formStatusListLoading: false };
    case FORM_STATUS_LIST_FAILURE:
      return { ...state, formStatusListError: action.payload, formStatusListLoading: false };
    case FORM_STATUS_CREATE:
      return { ...state, formStatusCreateLoading: true, formStatusCreateError: null };
    case FORM_STATUS_CREATE_SUCCESS:
      return { ...state, formStatusCreate: action.payload, formStatusCreateLoading: false };
    case FORM_STATUS_CREATE_FAILURE:
      return { ...state, formStatusCreateError: action.payload, formStatusCreateLoading: false };
    case FORM_STATUS_UPDATE:
      return { ...state, formStatusUpdateLoading: true, formStatusUpdateError: null };
    case FORM_STATUS_UPDATE_SUCCESS:
      return { ...state, formStatusUpdate: action.payload, formStatusUpdateLoading: false };
    case FORM_STATUS_UPDATE_FAILURE:
      return { ...state, formStatusUpdateError: action.payload, formStatusUpdateLoading: false };
    case FORM_STATUS_DELETE:
      return { ...state, formStatusDeleteLoading: true, formStatusDeleteError: null };
    case FORM_STATUS_DELETE_SUCCESS:
      return { ...state, formStatusDelete: action.payload, formStatusDeleteLoading: false };
    case FORM_STATUS_DELETE_FAILURE:
      return { ...state, formStatusDeleteError: action.payload, formStatusDeleteLoading: false };
    case FORMS_SET_STATUS:
      return { ...state, formsSetStatusLoading: true, formsSetStatusError: null };
    case FORMS_SET_STATUS_SUCCESS:
      return { ...state, formsSetStatus: action.payload, formsSetStatusLoading: false };
    case FORMS_SET_STATUS_FAILURE:
      return { ...state, formsSetStatusError: action.payload, formsSetStatusLoading: false };

    case FORMS_PUBLISH:
      return {
        ...state,
        formsPublishLoading: true,
        formsPublishError: null,
      };
    case FORMS_PUBLISH_SUCCESS:
      return {
        ...state,
        formsPublish: action.payload,
        formsPublishLoading: false,
      };
    case FORMS_PUBLISH_FAILURE:
      return {
        ...state,
        formsPublishLoading: false,
        formsPublishError: action.payload,
      };

    // Unpublish
    case FORMS_UNPUBLISH:
      return {
        ...state,
        formsUnpublishLoading: true,
        formsUnpublishError: null,
      };
    case FORMS_UNPUBLISH_SUCCESS:
      return {
        ...state,
        formsUnpublish: action.payload,
        formsUnpublishLoading: false,
      };
    case FORMS_UNPUBLISH_FAILURE:
      return {
        ...state,
        formsUnpublishLoading: false,
        formsUnpublishError: action.payload,
      };

    // Duplicate
    case FORMS_DUPLICATE:
      return {
        ...state,
        formsDuplicateLoading: true,
        formsDuplicateError: null,
      };
    case FORMS_DUPLICATE_SUCCESS:
      return {
        ...state,
        formsDuplicate: action.payload,
        formsDuplicateLoading: false,
      };
    case FORMS_DUPLICATE_FAILURE:
      return {
        ...state,
        formsDuplicateLoading: false,
        formsDuplicateError: action.payload,
      };

    // Delete
    case FORMS_DELETE:
      return {
        ...state,
        formsDeleteLoading: true,
        formsDeleteError: null,
      };
    case FORMS_DELETE_SUCCESS:
      return {
        ...state,
        formsDelete: action.payload,
        formsDeleteLoading: false,
      };
    case FORMS_DELETE_FAILURE:
      return {
        ...state,
        formsDeleteLoading: false,
        formsDeleteError: action.payload,
      };

    // Submissions list
    case FORMS_SUBMISSIONS:
      return {
        ...state,
        formsSubmissionsLoading: true,
        formsSubmissionsError: null,
      };
    case FORMS_SUBMISSIONS_SUCCESS:
      return {
        ...state,
        formsSubmissions: action.payload,
        formsSubmissionsLoading: false,
      };
    case FORMS_SUBMISSIONS_FAILURE:
      return {
        ...state,
        formsSubmissionsLoading: false,
        formsSubmissionsError: action.payload,
      };

    // Single submission
    case FORMS_SUBMISSION_DATA:
      return {
        ...state,
        formsSubmissionDataLoading: true,
        formsSubmissionDataError: null,
      };
    case FORMS_SUBMISSION_DATA_SUCCESS:
      return {
        ...state,
        formsSubmissionData: action.payload,
        formsSubmissionDataLoading: false,
      };
    case FORMS_SUBMISSION_DATA_FAILURE:
      return {
        ...state,
        formsSubmissionDataLoading: false,
        formsSubmissionDataError: action.payload,
      };

    default:
      return state;
  }
};

export default Forms;
